import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useState } from "react";
import Loader from "../loader/Loader";

const ModalUploadFile = (props) => {
  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        centered={true}
        backdrop={true}
      >
        <form onSubmit={props.handleSubmit} className="hidden-overflowAll">
          <Modal.Body className="upload-file-body">
            <h4 className="mt-2 mb-4">{props.title}</h4>
            <input
              className="mb-2"
              type="file"
              onChange={props.handleChooseFile}
            />
            {props.isShowLoader && <Loader loaderStyle={{ width: "30px" }}/>}
          </Modal.Body>
          {props.errorMessage && (
                  <div className="file-size-error-tooltip">
                    <span>{props.errorMessage}</span>
                  </div>
                )}
          <Modal.Footer>
            <button
              className="large-button grey"
              onClick={props.onHide}
            >
              CLOSE
            </button>
            {props?.isActiveUploadFileButton && (
              <button className="large-button green" type="submit">
                {props.buttonTittle}
              </button>
            )}
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
export default ModalUploadFile;
